import { render, staticRenderFns } from "./LeadsDetail.vue?vue&type=template&id=11995ded&"
import script from "./LeadsDetail.vue?vue&type=script&lang=js&"
export * from "./LeadsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports